import React from 'react';
import { MLabel, MIcon } from 'src/theme';
import { PATH_CUSTOMER_MOBILE } from 'src/routes/paths';


import { Icon } from '@iconify/react';
import bxHome from '@iconify/icons-bx/bx-home';
import bookIcon from '@iconify/icons-akar-icons/book';
import bellFill from '@iconify-icons/eva/bell-fill';
import bxsOffer from '@iconify/icons-bx/bxs-offer';
import boxIcon from '@iconify/icons-la/box';
import fileInvoice from '@iconify/icons-la/file-invoice';
import creditCardOutlined from '@iconify/icons-ant-design/credit-card-outlined';
import moneyBill from '@iconify/icons-fa-solid/money-bill';
import buildingWarehouse from '@iconify/icons-tabler/building-warehouse';
import personIcon from '@iconify/icons-akar-icons/person';
import reportIcon from '@iconify/icons-carbon/report';

import idCard from '@iconify/icons-bx/id-card';
import groupIcon from '@iconify/icons-el/group';

import paymentUpdate from '@iconify/icons-tabler/file-dollar';

// ----------------------------------------------------------------------

const path = (name) => `/static/icons/navbar/${name}.svg`;

const ICONS = {
  home: <Icon icon={bxHome} style={{ width: '2em', height: '2em'}}/>,
  userGuide: <Icon icon={bookIcon} style={{ width: '2em', height: '2em'}}/>,
  notifications: <Icon icon={bellFill} style={{ width: '2em', height: '2em'}}/>,
  offers: <Icon icon={bxsOffer} style={{ width: '2em', height: '2em'}}/>,
  preOrder: <Icon icon={boxIcon} style={{ width: '2em', height: '2em'}}/>,
  order: <Icon icon={fileInvoice} style={{ width: '2em', height: '2em'}}/>,
  payment: <Icon icon={creditCardOutlined} style={{ width: '2em', height: '2em'}}/>,
  distributor: <Icon icon={buildingWarehouse} style={{ width: '2em', height: '2em'}}/>,
  report: <Icon icon={reportIcon} style={{ width: '2em', height: '2em'}}/>,
  profile: <Icon icon={personIcon} style={{ width: '2em', height: '2em'}}/>,
  reportIcon: <Icon icon={reportIcon} style={{ width: '2em', height: '2em'}}/>,
  companyAccount: <Icon icon={idCard} style={{ width: '2em', height: '2em' }}/>,
  staffIcon: <Icon icon={groupIcon} style={{ width: '2em', height: '2em' }}/>,
  creditNote: <Icon icon={moneyBill} style={{ width: '2em', height: '2em' }}/>,
  paymentUpdate: <Icon icon={paymentUpdate} style={{ width: '2em', height: '2em' }}/>
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'home',
        icon: ICONS.home,
        href: PATH_CUSTOMER_MOBILE.general.root
      },
      {
        title: 'user guide',
        icon: ICONS.userGuide,
        href: PATH_CUSTOMER_MOBILE.general.root
      },
      {
        title: 'notifications',
        icon: ICONS.notifications,
        href: PATH_CUSTOMER_MOBILE.general.notifications,
        badgeModule: 'notification',
        staffAccess: 'notifications'
      },
      {
        title: 'company profile',
        icon: ICONS.companyAccount,
        href: PATH_CUSTOMER_MOBILE.general.retailerApplicationForm,
        badgeModule: 'companyProfileRetailer',
        staffAccess: 'companyProfile'
      }
    ]
  },
  {
    subheader: 'offers',
    items: [
      {
        title: 'offers',
        icon: ICONS.offers,
        access: 'offers',
        href: PATH_CUSTOMER_MOBILE.general.offers,
        badgeModule: 'offerRetailer',
        staffAccess: 'offers'
      },
      {
        title: 'closed offers',
        icon: ICONS.offers,
        access: 'closedOffers',
        href: PATH_CUSTOMER_MOBILE.general.closedOffers,
        staffAccess: 'closedOffers'
      }
    ]
  },
  {
    subheader: 'pre-order',
    items: [
      {
        title: 'pre-order',
        icon: ICONS.preOrder,
        access: 'preOrder',
        href: PATH_CUSTOMER_MOBILE.general.preOrder,
        badgeModule: 'preOrderRetailer',
        staffAccess: 'preOrder'
      },
      {
        title: 'staff pre-order',
        icon: ICONS.preOrder,
        href: PATH_CUSTOMER_MOBILE.general.staffPreOrder,
        access: 'staffPreOrder',
        hideForStaff: true
      }
    ]
  },
  {
    subheader: 'instock',
    items: [
      {
        title: 'catalogue',
        icon: ICONS.preOrder,
        href: PATH_CUSTOMER_MOBILE.general.catalogue,
        access: 'catalogue',
        items: [],
        disabledCollapse: true,
        staffAccess: 'catalogue'
      },
      {
        title: 'restock order',
        icon: ICONS.preOrder,
        href: PATH_CUSTOMER_MOBILE.general.restockOrder,
        access: 'restock',
        badgeModule: 'restockOrderRetailer',
        staffAccess: 'restock'
      }
    ]
  },
  {
    subheader: 'sales',
    items: [
      /** {
        title: 'all order',
        icon: ICONS.order,
        access: 'allOrder',
        href: PATH_CUSTOMER_MOBILE.general.orderAll,
        badgeModule: 'orderRetailer'
      }, */
      {
        title: 'orders',
        icon: ICONS.order,
        access: 'orders',
        href: PATH_CUSTOMER_MOBILE.general.order,
        badgeModule: 'orderRetailer',
        staffAccess: 'orders'
      },
      {
        title: 'payment',
        icon: ICONS.payment,
        href: PATH_CUSTOMER_MOBILE.general.payment,
        staffAccess: 'payment'
      },
      {
        title: 'payment update',
        icon: ICONS.paymentUpdate,
        href: PATH_CUSTOMER_MOBILE.general.paymentUpdate,
        staffAccess: 'paymentUpdate'
      },
      {
        title: 'order issues',
        icon: ICONS.order,
        href: PATH_CUSTOMER_MOBILE.general.orderIssues,
        badgeModule: 'orderIssuesRetailer',
        staffAccess: 'orderIssues'
      },
      {
        title: 'overpayment',
        icon: ICONS.creditNote,
        href: PATH_CUSTOMER_MOBILE.general.overpayment,
        staffAccess: 'creditNote'
      }
    ]
  },
  {
    subheader: 'Consignment MGMT.',
    items: [
      {
        title: 'consignment',
        icon: ICONS.order,
        access: 'consignment',
        href: PATH_CUSTOMER_MOBILE.general.consignment,
        badgeModule: 'orderConsignmentRetailer',
        staffAccess: 'consignment'
      },
      {
        title: 'Stock Returnable',
        icon: ICONS.reportIcon,
        access: 'stockReturnable',
        href: PATH_CUSTOMER_MOBILE.general.consignmentStockReturnable,
        badgeModule: 'consignmentStockReturnableRetailer',
        staffAccess: 'stockReturnable'
      },
      {
        title: 'report',
        icon: ICONS.reportIcon,
        access: 'consignmentReport',
        href: PATH_CUSTOMER_MOBILE.general.consignmentReport,
        staffAccess: 'report'
      },
      // {
      //   title: 'SKU Order',
      //   icon: ICONS.order,
      //   access: 'consignmentSKUOrder',
      //   href: PATH_CUSTOMER_MOBILE.general.consignmentSkuOrder,
      //   staffAccess: 'consignmentSKUOrder'
      // },
      {
        title: 'stock products',
        icon: ICONS.order,
        access: 'consignmentStockProducts',
        href: PATH_CUSTOMER_MOBILE.general.stockProducts,
        staffAccess: 'consignmentStockProducts'
      }
    ]
  },
  {
    subheader: 'management',
    items: [
      {
        title: 'distributor',
        icon: ICONS.distributor,
        href: PATH_CUSTOMER_MOBILE.general.distributor,
        badgeModule: 'distributorRetailer',
        staffAccess: 'distributor'
        //hideForStaff: true
      },
      {
        title: 'report',
        icon: ICONS.report,
        href: PATH_CUSTOMER_MOBILE.general.report,
        staffAccess: 'report'
      },
      {
        title: 'staff',
        icon: ICONS.staffIcon,
        href: PATH_CUSTOMER_MOBILE.general.staff,
        staffAccess: 'staff'
      },
      {
        title: 'profile',
        icon: ICONS.profile,
        href: PATH_CUSTOMER_MOBILE.general.profile
      },
      /**{
        title: 'Retailer Application Form',
        icon: ICONS.reportIcon,
        href: PATH_CUSTOMER_MOBILE.general.retailerApplicationForm
      }*/
    ]
  }
];

export default navConfig;
